// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2bsdZ","notes":"Notes_notes__1yrEP","note":"Notes_note__3Z3wC","markdown":"Notes_markdown__1gxq2"};